// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomerLayout_wrapper__4E4ty","expandable":"CustomerLayout_expandable__BxtBp","mainLoader":"CustomerLayout_mainLoader__LHztC"};